import React from "react";
import {resourcePrefixType} from "../util/Enums";
import {VirtualHost} from "../constants";

function UnderConstructionPage() {
    return (
        <div>
            <h1 style={{textAlign: "center", fontFamily: "arial"}}>
                Sitemiz Bakım Aşamasındadır.
            </h1>
            {resourcePrefixType.optikkart === VirtualHost.resourcePrefix &&
                <h3 style={{textAlign: "center", fontFamily: "arial"}}>
                    Optik Kart yenilenen yüzü ile sizlere hizmet vermeye devam edecektir. Anlayışınız için teşekkür ederiz.
                </h3>
            }

            {resourcePrefixType.tebeczacikart === VirtualHost.resourcePrefix &&
                <h3 style={{textAlign: "center", fontFamily: "arial"}}>
                    TEB Eczacı Kart yenilenen yüzü ile sizlere IOS ve Android uygulama marketlerdeki mobil uygulamamız
                    üzerinden hizmet vermeye devam etmektedir. Bu aşamadaki işlemlerinizi mobil uygulama üzerinden
                    yapabilirsiniz. Anlayışınız için teşekkür ederiz.
                </h3>
            }

            {resourcePrefixType.tebeczacikart === VirtualHost.resourcePrefix &&
                <p style={{textAlign: "center", fontFamily: "arial"}}>
                    İOS Linki: <a href="https://apps.apple.com/tr/app/teb-eczac%C4%B1-kart/id1638721491"> https://apps.apple.com/tr/app/teb-eczac%C4%B1-kart/id1638721491</a>
                </p>
            }

            {resourcePrefixType.tebeczacikart === VirtualHost.resourcePrefix &&
                <p style={{textAlign: "center", fontFamily: "arial"}}>
                    Android Linki: <a href=">https://play.google.com/store/apps/details?id=com.kolaysoft.KirmiziKurumsal&hl=en_US">https://play.google.com/store/apps/details?id=com.kolaysoft.KirmiziKurumsal&hl=en_US</a>
                </p>
            }
        </div>
    )
}

export default UnderConstructionPage;


// WEBPACK FOOTER //
// ./src/page/UnderConstructionPage.js